import React from 'react';
import Link from 'components/Link';
import s from './ResourceLinks.scss';

function ResourceLinks({
  sectionData,
  isWapView,
  sectionClass,
  isReviewsPage,
}) {
  return (
    <div
      className={`${isReviewsPage ? s.reviews_link : ''} ${s.resourceLinks} ${
        s[sectionClass]
      }`}
    >
      {(sectionData?.name || sectionData?.label || sectionData?.subHeading) && (
        <div className={s.resourceLinksTitle}>
          {sectionData?.label && (
            <>
              {sectionData?.name ? (
                <div className={s.elbMianTitle}>{sectionData?.name}</div>
              ) : (
                <div className={s.elbMianTitle}>{sectionData?.label}</div>
              )}
              {!isWapView && <span />}
            </>
          )}
          {sectionData?.subHeading && (
            <div className={s.elbSubTitle}>{sectionData?.subHeading}</div>
          )}
        </div>
      )}
      <div className={s.resourceLinksInner}>
        <div className={s.linkWrap}>
          {sectionData.items.map((item, dataIndex) => (
            <Link
              key={dataIndex}
              to={item.wu}
              title={item.hl}
              ga4Data={
                sectionData.ga4Type && [
                  {
                    event: 'user_click',
                    type: `${sectionData.ga4Type}`,
                    category: 'story_click',
                    story_no: `${dataIndex}`,
                  },
                ]
              }
            >
              {item.hl}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ResourceLinks;
